export const products = {
  MSRP: "MSRP",
  LogInForPricing: "Log in for pricing",
  FilledOnSite: "Filled on-site",
  OnlyOnFullscript: "Only on Fullscript",
  Unit: "/ unit",
  WhatsInside: "What's inside",
  productImageCarousel: {
    enlarge: "Click to enlarge product image.",
    viewImage: "View image {{current}} of {{total}}",
    previousImageOfProduct: "Previous image of {{productName}}",
    nextImageOfProduct: "Next image of {{productName}}",
  },
} as const;
